import { EXPORTAR_EXCEL_OPERACION_BY_FILTERS } from '@/graphQLQueries/OperacionQueries'
import DownloadsMixin from "@/utils/downloads";
import Vue from 'vue'

var ExportExcelMixin = Vue.util.mergeOptions(DownloadsMixin, {
  data: () => ({
    erroresExportacion: [],
    exportandoDatos: false
  }),
  methods: {
    exportarExcelOperacionByFilters(filters, sort) {
      this.exportandoDatos = true

      this.$apollo.query({
        query: EXPORTAR_EXCEL_OPERACION_BY_FILTERS,
        variables: {
          lang: this.$i18n.locale,
          criteria: {
            filter: filters,
            page: 0,
            size: 999999,
            sort: sort
          },
          fetchPolicy: 'no-cache'
        }
      }).then((data) => {
        this.exportandoDatos = false
        const exportarExcelOperacionByFiltersData = data.data.exportarExcelOperacionByFilters
        if (exportarExcelOperacionByFiltersData.rows > 0)
          this.download(exportarExcelOperacionByFiltersData.fileName, exportarExcelOperacionByFiltersData.fileData, document)

      }).catch((error) => {
        this.exportandoDatos = false
        console.error(error)
        this.erroresExportacion = []
        error.graphQLErrors.forEach(error => {
          this.erroresExportacion.push(this.$i18n.t("operacion.exportacion.errores." + error.message));
        })
      })
    }
  }
});

export default ExportExcelMixin;